import * as React from 'react';
import { useNavigate, useParams } from 'react-router';
import { FileParameter, ImportProjetBudgetRequest, LandType, PartnerDto, ProjectBudgetDTO, ProjectDto, ProjectsRycApiClient, UndergroundMaterial, UpdateProjectRequest } from '../Api/ApiServer';
import { useApi } from '../Api/useApi';
import 'dayjs/locale/cs';
import { Autocomplete, Box, Button, Grid2, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useProject } from '../Contexts/Hooks/useProject';
import { RycIsProjectModule } from '../Enums/RycIsProjectModule';
import { DeleteOutline, Money, SaveOutlined, Timelapse } from '@mui/icons-material';
import DeleteDialog from '../Shared/DeleteDialog';
import { useSnackbar } from 'notistack';
import { ImportBudget } from './ImportBudget';
import ProjectBudget from './ProjectBudget';
import QuestionDialog from '../Shared/QuestionDialog';
import PartnerSelectComponent, { PartnerSelectComponentRef } from './Components/PartnerSelectComponent';
import ColoredGadget from '../Shared/ColoredGadget';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { getCurrentGiff } from '../Shared/GetGiffBasedOnLandType';
import { useRef } from 'react';

export interface IProjectDetailProps {
}
const landTypeLabels: Record<LandType, string> = {
    [LandType.Flat]: 'Rovina',
    [LandType.Cross]: 'Křížem',
    [LandType.Dig]: 'Výkop',
    [LandType.LongFlat]: 'Podélná rovina',
};

const undergroundMaterialsLabels: Record<UndergroundMaterial, string> = {
    [UndergroundMaterial.Jil]: 'Jíl',
    [UndergroundMaterial.Rock]: 'Skála',
    [UndergroundMaterial.Sand]: 'Písek',
    [UndergroundMaterial.Stones]: 'Kameny',
};
export default function ProjectDetail(props: IProjectDetailProps) {
    const params = useParams<{ id: string }>();
    const [project, setProject] = React.useState<ProjectDto | null>(null);
    const [projectBudget, setProjectBudget] = React.useState<ProjectBudgetDTO[]>([]);
    const { authorizedApi } = useApi(ProjectsRycApiClient);
    const [changed, setChanged] = React.useState(false);

    const { setCurrentModule, setMenuButtons } = useProject();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();


    const saveProject = React.useCallback(async () => {
        if (project) {
            await authorizedApi?.updateProject(new UpdateProjectRequest(project));
            setChanged(false);
            enqueueSnackbar('Uloženo', { variant: 'success', autoHideDuration: 1000 });
        }
    }, [authorizedApi, project, enqueueSnackbar]);
    const load = async () => {
        const id = Number(params.id);
        if (isNaN(id)) {
            console.error('Invalid id', params.id);
            return;
        }
        const project = await authorizedApi?.getProject(id);
        setProject(project?.project ?? null);
    };
    React.useEffect(() => {


        load();

    }, [params.id, authorizedApi]);

    // React.useEffect(() => {
    //     if (project?.id) {
    //         console.log(project?.id);
    //       getProjectBudget(project?.id);
    //     }
    // }, [project]);

    React.useEffect(() => {
        setCurrentModule(RycIsProjectModule.Detail);
    }, [setCurrentModule]);
    const theme = useTheme();
    const biggerThan500 = useMediaQuery(theme.breakpoints.up(500));
    React.useEffect(() => {
        console.log('changed', changed, project);
        setMenuButtons(<Box>
            <Button color='secondary' sx={{ m: 1 }} size='small' variant='contained' disabled={!changed || project?.name === ''} startIcon={biggerThan500 ? <SaveOutlined /> : undefined} onClick={saveProject}>{biggerThan500 ? 'Uložit' : <SaveOutlined />}</Button>
            <Button color='secondary' sx={{ m: 1 }} size='small' variant='contained' startIcon={biggerThan500 ? <DeleteOutline /> : undefined} onClick={() => setDeletingProject(project)}>{biggerThan500 ? 'Smazat' : <DeleteOutline />}</Button>
        </Box>);
    }, [setMenuButtons, changed, project, saveProject]);
    const handleChange = (field: keyof ProjectDto) => (e: React.ChangeEvent<HTMLInputElement>) => {
        setProject({ ...project, [field]: e.currentTarget.value } as ProjectDto);
        setChanged(true);
    };

    // const getProjectBudget = React.useCallback(async (id: number) => {
    //     if (project && project.id) {
    //         const budget = await authorizedApi?.projectBudget(id);
    //         setProjectBudget(budget?.budgetItems ?? []);
    //     }
    // }, [authorizedApi, project]);

    const [selectedOrderer, setSelectedOrderer] = React.useState<PartnerDto | null>(null);
    const [selectedSupplier, setSelectedSupplier] = React.useState<PartnerDto | null>(null);
    const [deletingProject, setDeletingProject] = React.useState<ProjectDto | null>(null);
    const objednatelSelectRef = useRef<PartnerSelectComponentRef>(null);
    const zhotovitelSelectRef = useRef<PartnerSelectComponentRef>(null);

    const handleSelectsRefresh = () => {
        objednatelSelectRef.current?.loadPartners();
        zhotovitelSelectRef.current?.loadPartners();
    };

    const [isHoveringGif, setIsHoveringGif] = React.useState(false);
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    // Add this function to your component
    const handleReuploadClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const response = await authorizedApi?.uploadProjectImage({ data: file, fileName: file.name } as FileParameter, project?.id ?? 0);
            if (response?.imageDownloadUri && project) {
                setProject({ ...project, imageUri: response.imageDownloadUri } as ProjectDto);
            }
            // Reset file input to allow re-uploading the same file
            event.target.value = '';
        }
    };

    return (
        <Box overflow='auto' height={'calc(100vh - 144px)'}>
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                accept="image/*"
            />
            <DeleteDialog
                onDeleteAgree={async (data) => {
                    if (data) {
                        console.log('delete', data);
                        await authorizedApi?.deleteProject(data.id);
                        setDeletingProject(null);
                        navigate('/logged/projects');

                    }
                }}
                data={deletingProject}
                open={deletingProject !== null}
                onClose={(data) => {
                    setDeletingProject(null);
                }} />
            <Grid2 pt={2} spacing={1} container>
                {/* <Grid2 > */}
                <Grid2
                    size={{ xl: 6, lg: 6, md: 12, sm: 12 }}
                    order={{ xl: 1, lg: 1, md: 2, sm: 2, xs: 2 }}
                    container spacing={1}>
                    <Grid2 px={2} size={{ xs: 6 }}><ColoredGadget icon={<Money color='primary' sx={{ fontSize: 48 }} />} upperText='Celková cena na klíč' lowerText={(project?.totalPrice?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) ?? '0,00') + ' Kč'} /></Grid2>
                    <Grid2 px={2} size={{ xs: 6 }}><ColoredGadget icon={<Timelapse color='primary' sx={{ fontSize: 48 }} />} upperText='Montáž' lowerText={((project?.totalPrice ?? 0) / 10000).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) +' hodin'} /></Grid2>
                    <Grid2 size={{ xs: 12 }}>

                        {project?.imageUri && <Box
                            position="relative"
                            display="inline-block"
                            onMouseEnter={() => setIsHoveringGif(true)}
                            onMouseLeave={() => setIsHoveringGif(false)}
                        >
                            <img height={'240px'} src={project?.imageUri} />
                            {isHoveringGif && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={() => handleReuploadClick()}
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        opacity: 0.9,
                                    }}
                                >
                                    Nahrát nový
                                </Button>
                            )}
                        </Box>}
                        {!project?.imageUri && <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => handleReuploadClick()}
                            sx={{ mt: 3 }}
                        // sx={{
                        //     position: 'absolute',
                        //     top: '50%',
                        //     left: '50%',
                        //     transform: 'translate(-50%, -50%)',
                        //     opacity: 0.9,
                        // }}
                        >
                            Nahrát obrázek
                        </Button>}

                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                        <Grid2 container p={2} px={4} spacing={1}>
                            <Grid2 size={{ xs: 12 }}>
                                <Typography color='primary' variant='h6'>PARAMETRY</Typography>
                            </Grid2>
                            <Grid2 size={{ xs: 12 }}>
                                <TextField
                                    label='Délka pasů v metrech'
                                    type='number'
                                    fullWidth
                                    value={project?.longitudeOfBelts ?? 0}
                                    onChange={handleChange('longitudeOfBelts')} />
                            </Grid2>
                            <Grid2 size={{ xs: 12 }}>
                                <TextField label='Plocha desky v m²'
                                    type='number'
                                    fullWidth
                                    value={project?.area ?? 0}
                                    onChange={handleChange('area')}
                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12 }}>
                                <Autocomplete
                                    options={Object.values(UndergroundMaterial).filter(value => typeof value === 'number')}
                                    getOptionLabel={(option) => undergroundMaterialsLabels[option as UndergroundMaterial] ?? ''}
                                    renderInput={(params) => <TextField {...params} label="Materiál podloží" />}
                                    onChange={(event, value) => {
                                        // Handle the selection change here
                                        setProject({ ...project, undergroundMaterial: value as UndergroundMaterial } as ProjectDto);
                                        setChanged(true);
                                    }}
                                    value={project?.undergroundMaterial ?? null}
                                />
                                {/* <TextField label='Materiál podloží' /> */}
                            </Grid2>
                            <Grid2 size={{ xs: 12 }}>
                                <Autocomplete
                                    options={Object.values(LandType).filter(value => typeof value === 'number')}
                                    getOptionLabel={(option) => landTypeLabels[option as LandType] ?? ''}
                                    renderInput={(params) => <TextField {...params} label="Zasazení do terénu" />}
                                    onChange={(event, value) => {
                                        // Handle the selection change here
                                        setProject({ ...project, landType: value as LandType } as ProjectDto);
                                        setChanged(true);
                                    }}
                                    value={project?.landType ?? null}
                                />
                            </Grid2>
                        </Grid2>
                    </Grid2>
                    <Grid2 mt={4} size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                        {project?.landType && <img height={'220px'} src={getCurrentGiff(project.landType)} />}
                    </Grid2>
                </Grid2>
                <Grid2 pl={1} textAlign={'start'} pr={2}
                    order={{ xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} size={{ xl: 6, lg: 6, md: 12, sm: 12 }}>
                    <Grid2 container spacing={1}>
                        <Grid2 size={{ xs: 12 }}>
                            <Typography variant='h6' color='primary'>PROJEKT</Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                            <TextField
                                fullWidth
                                label='Název projektu'
                                value={project?.name ?? ''}
                                onChange={handleChange('name')}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                            <TextField
                                fullWidth
                                label='Číslo zakázky'
                                value={project?.orderNumber ?? ''}
                                onChange={handleChange('orderNumber')}

                            />
                        </Grid2>
                        <Grid2 size={{ xs: 6 }}>
                            <LocalizationProvider adapterLocale='cs' dateAdapter={AdapterDayjs}>
                                <DatePicker label='Zahájení'
                                    onChange={(val) => {
                                        setProject(new ProjectDto({ ...project, beginDate: val?.toDate() }));
                                        setChanged(true);
                                    }}
                                    value={project?.beginDate ? dayjs(project.beginDate) : null} />
                            </LocalizationProvider>
                        </Grid2>
                        <Grid2 size={{ xs: 6 }}>
                            <LocalizationProvider adapterLocale='cs' dateAdapter={AdapterDayjs}>
                                <DatePicker label='Dokončení'
                                    onChange={(val) => {
                                        setProject(new ProjectDto({ ...project, endDate: val?.toDate() }));
                                        setChanged(true);
                                    }}
                                    value={project?.endDate ? dayjs(project.endDate) : null}
                                />
                            </LocalizationProvider>
                        </Grid2>
                        <Grid2 mt={2} size={{ xs: 12 }}>
                            <Typography variant='h6' color='primary'>ZÁKAZNÍK</Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                            <PartnerSelectComponent selectedPartnerId={project?.ordererPartnerId} onPartnerSelect={(partner, fromLoad) => {
                                setProject(new ProjectDto({ ...project, ordererPartnerId: partner?.id }));
                                setSelectedOrderer(partner);
                                if (!fromLoad)
                                    setChanged(true);
                            }} title={'Vyberte objednatele'} ref={objednatelSelectRef} onRefresh={handleSelectsRefresh} />
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                            <TextField
                                fullWidth
                                label='Adresa'
                                value={selectedOrderer?.address ?? ''}
                            />
                        </Grid2>
                        <Grid2 pr={1} size={{ xs: 6 }}>
                            <TextField
                                fullWidth
                                label='Email'
                                value={selectedOrderer?.email ?? ''}
                            />
                        </Grid2>
                        <Grid2 pl={1} size={{ xs: 6 }}>
                            <TextField
                                fullWidth
                                label='Telefon'
                                value={selectedOrderer?.phone ?? ''}
                            />
                        </Grid2>
                        <Grid2 mt={2} size={{ xs: 12 }}>
                            <Typography variant='h6' color='primary'>ZHOTOVITEL</Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                            <PartnerSelectComponent selectedPartnerId={project?.supplierPartnerId} onPartnerSelect={(partner, fromLoad) => {
                                setProject(new ProjectDto({ ...project, supplierPartnerId: partner?.id }));
                                setSelectedSupplier(partner);
                                if (!fromLoad)
                                    setChanged(true);
                            }} title={'Vyberte zhotovitele'} ref={zhotovitelSelectRef} onRefresh={handleSelectsRefresh} />
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                            <TextField
                                fullWidth
                                label='Adresa'
                                value={selectedSupplier?.address ?? ''}
                            />
                        </Grid2>
                        <Grid2 pr={1} size={{ xs: 6 }}>
                            <TextField
                                fullWidth
                                label='Email'
                                value={selectedSupplier?.email ?? ''}
                            />
                        </Grid2>
                        <Grid2 pl={1} size={{ xs: 6 }}>
                            <TextField
                                fullWidth
                                label='Telefon'
                                value={selectedSupplier?.phone ?? ''}
                            />
                        </Grid2>

                    </Grid2>
                </Grid2>

            </Grid2>

        </Box>
    );
}
